import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _get from "lodash/get";
import _map from "lodash/map";
import _pick from "lodash/pick";
const _excluded = ["items"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import { load } from 'js-yaml';
import { MigrationResult } from './migration-result';
const getFlavor = solution => {
  if (solution.length > 2) {
    return 'Classify';
  }
  const isParsons = solution.every(item => item.maxOffset && item.maxOffset > 0);
  if (isParsons) {
    return 'Parsons';
  }
  return 'Order';
};
export const migrateV0ToV1 = data => {
  const baseData = _pick(data, ['title', 'xp', 'course_id', 'chapter_id', 'assignment', 'hint', 'instructions']);
  const correctnessConditions = load(data.sct);
  const solution = load(data.solution);
  const checks = _map(_get(correctnessConditions, 'checks'), item => {
    return {
      condition: item.condition,
      message: item.correctMessage !== undefined ? item.correctMessage : item.incorrectMessage,
      shouldBe: item.correctMessage === undefined
    };
  });
  const flavor = getFlavor(solution);
  return new MigrationResult('v1', _objectSpread(_objectSpread({}, baseData), {}, {
    question: {
      correctnessConditions: _objectSpread(_objectSpread({
        /* @ts-expect-error ??? */
        isOrdered: false,
        /* @ts-expect-error ??? */
        successMessage: 'Well done!'
      }, _pick(correctnessConditions, ['successMessage', 'failureMessage', 'isOrdered'])), {}, {
        checks
      }),
      flavor,
      solution
    }
  }));
};
export const migrateV1ToV2 = data => {
  const question = _objectSpread(_objectSpread({}, data.question), {}, {
    solution: data.question.solution.map(_ref => {
      let {
          items
        } = _ref,
        rest = _objectWithoutProperties(_ref, _excluded);
      return _objectSpread(_objectSpread({}, rest), {}, {
        draggableItems: items
      });
    })
  });
  return new MigrationResult('v2', _objectSpread(_objectSpread({}, data), {}, {
    question
  }));
};
export const migrations = {
  v0: migrateV0ToV1,
  v1: migrateV1ToV2
};
export default migrations;